import type { FaireAdvertiserProfileEntity } from "../../entity_types/advertiserProfile";

// Verve Culture (b_6xvu4qtx, advertiser 5400991603711502745).
// Lifetime complete-month metrics through Aug 2026.
export const advVerveCulture: FaireAdvertiserProfileEntity = {
  token: "adv_verve_culture",
  type: "advertiserProfile",
  archetype: "budget-capped",
  displayName: "Verve Culture",
  brandToken: "b_6xvu4qtx",
  audienceType: "NEW_AND_RETURNING",
  globalStatus: "ACTIVE",
  tenureMonths: 35,
  budget: {
    totalBudgetDollars: 1800,
    sharedBudgetDollars: 1800,
    spendingMode: "MODERATE",
    nextRenewsAtDate: "2026-10-01",
    nextBillsAtDate: "2026-10-04",
  },
  overview: {
    numCustomersAcquired: 490,
    numReorderConversions: 308,
    numTotalConversions: 798,
    totalAdsSalesDollars: 443364,
    newCustomerAdsSalesDollars: 311898,
    reorderAdsSalesDollars: 131466,
    totalAdsSpendDollars: 52423,
    newCustomerAdsSpendDollars: 42419,
    reorderAdsSpendDollars: 10004,
    newCustomerBestEstimateFirstYearRoas: 7.42,
    reorderRoas: 13.14,
    combinedFirstYearRoas: 8.51,
    numNewCustomerAdsOrders: 1242,
    numReorderAdsOrders: 483,
  },
  availableCredit: { totalRemainingDollars: 0 },
  budgetRecommendations: {
    newCustomer: {
      minRecommendedBudgetDollars: 1980,
      maxRecommendedBudgetDollars: 3960,
      isEligibleForIncreaseRec: true,
    },
    reorder: {
      minRecommendedBudgetDollars: 730,
      maxRecommendedBudgetDollars: 1460,
      isEligibleForIncreaseRec: false,
    },
  },
  campaignTokens: ["camp_vc_new", "camp_vc_reorder"],
  overviewPerformancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-24T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
